import React from 'react';
import { IAuditoriaSplitDespesasResultado } from '../interfaces/IAuditoriaSplitDespesas';

interface Props {
  resultado: IAuditoriaSplitDespesasResultado;
  onVerDetalhe: () => void;
}

const formatCurrency = (value?: number) =>
  (value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const StatusBadge: React.FC<{ status: string }> = ({ status }) => {
  const cls =
    status === 'ERRO'          ? 'badge-light-danger' :
    status === 'ALERTA'        ? 'badge-light-warning' :
    status === 'AVISO'         ? 'badge-light-warning' :
    status === 'NAO_ANALISADO' ? 'badge-light-secondary' :
                                 'badge-light-success';
  const label = status === 'NAO_ANALISADO' ? 'NÃO ANALISADO' : status;
  return <span className={`badge ${cls}`}>{label}</span>;
};

const AuditoriaResumoSplitDespesas: React.FC<Props> = ({ resultado, onVerDetalhe }) => {
  if (resultado.status === 'CONCILIADO' && resultado.grupos.length === 0) return null;

  const top5 = resultado.grupos
    .sort((a, b) => b.valorTotalFragmentado - a.valorTotalFragmentado)
    .slice(0, 5);

  return (
    <div className='card card-custom card-stretch mb-5'>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-4 mb-1'>
            Fragmentação de Despesas ("Split" Contábil)
          </span>
          <span className='text-muted mt-1 fw-bold fs-7'>
            CPC 00 (R2) · Lei 6.404/76 Art. 177 · Lei 9.430/96 Art. 44 I
          </span>
        </h3>
        <div className='card-toolbar'>
          <button className='btn btn-sm btn-light-primary' onClick={onVerDetalhe}>
            Ver Detalhes
          </button>
        </div>
      </div>

      <div className='card-body pt-3'>
        {resultado.status === 'NAO_ANALISADO' && (
          <div className='alert alert-secondary py-3 mb-5'>
            <strong>NÃO ANALISADO:</strong> {resultado.mensagemDirecionamento}
          </div>
        )}

        <div className='row mb-5'>
          <div className='col-3 text-center border-end'>
            <div className='fs-2 fw-bolder text-danger'>{resultado.totalErros}</div>
            <div className='text-muted fs-8'>Erros (&gt; 5 % da média)</div>
          </div>
          <div className='col-3 text-center border-end'>
            <div className='fs-2 fw-bolder text-warning'>{resultado.totalAlertas}</div>
            <div className='text-muted fs-8'>Alertas (1–5 %)</div>
          </div>
          <div className='col-3 text-center border-end'>
            <div className='fs-2 fw-bolder text-warning'>{resultado.totalAvisos}</div>
            <div className='text-muted fs-8'>Avisos (&lt; 1 %)</div>
          </div>
          <div className='col-3 text-center'>
            <div className='fs-2 fw-bolder text-danger'>
              {formatCurrency(resultado.passivoTributarioTotal)}
            </div>
            <div className='text-muted fs-8'>Passivo Estimado</div>
          </div>
        </div>

        {top5.length > 0 && (
          <div className='table-responsive'>
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-3'>
              <thead>
                <tr className='fw-bolder text-muted'>
                  <th>Empresa</th>
                  <th>Conta</th>
                  <th>Fornecedor / Histórico</th>
                  <th className='text-end'>Qtd. Lanç.</th>
                  <th className='text-end'>Total Fragmentado</th>
                  <th className='text-center'>Status</th>
                </tr>
              </thead>
              <tbody>
                {top5.map((g, i) => (
                  <tr key={i}>
                    <td>
                      <span className='fw-bold'>{g.empresaNome}</span>
                      <br />
                      <span className='text-muted fs-8'>{g.cnpj}</span>
                    </td>
                    <td>
                      <span className='fw-bold'>{g.contaReferencial}</span>
                      <br />
                      <span className='text-muted fs-8'>{g.descricaoConta}</span>
                    </td>
                    <td className='text-muted fs-8' style={{ maxWidth: '200px', wordBreak: 'break-word' }}>
                      {g.fornecedorHistorico}
                    </td>
                    <td className='text-end fw-bold'>{g.quantidadeLancamentos}</td>
                    <td className='text-end fw-bold'>{formatCurrency(g.valorTotalFragmentado)}</td>
                    <td className='text-center'><StatusBadge status={g.status} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AuditoriaResumoSplitDespesas;
